import { type ConfigData } from "../config-data";

const config: ConfigData = {
	rules: {
		"input-missing-label": "error",
		"heading-level": "error",
		"missing-doctype": "error",
		"no-missing-references": "error",
		"require-sri": "error",
	},
};

export default config;
